import { BuiltinInterface } from '../BuiltinInterface';
class TemplateStringsArrayInterface extends BuiltinInterface {
}
export const add = (builtins) => {
    builtins.addInterface('TemplateStringsArray', new TemplateStringsArrayInterface());
};

//# sourceMappingURL=index.js.map
